import React from 'react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { customAlert, notify } from '../../../components/notify';
import { useAuthContext } from '../../../context/AuthContext';
import BgBox from '../../../components/BgBox';
import ScrollBox from '../../../components/ScrollBox';
import { Box, Stack } from '@mui/system';
import { Button, Divider, IconButton, TextField, Typography } from '@mui/material';
import CustomRadio from '../../../components/CustomRadio';
import validate from './validate';
import { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import route from '../../../Routes';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../QueryKey';
import LoadingScreen from '../../../components/loadingScreen';
import { Add, DeleteForever } from '@mui/icons-material';
import CustomDropDown from '../../../components/CustomDropDown';
import CtrlFillLabelTxtField from '../../../components/CtrlFillLabelTxtField';
import { formatINRCurrency } from '../../../utils/format';
import { getSingleTrkOpReq, putTrkOpPricing } from '../../../services/req_service';


function EditTrkOpPricing() {
  const [formErrors, setFormErrors] = useState({});
  const { setLoadingScreen } = useAuthContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { trkOpReqId } = useParams();
  const { t } = useTranslation();
  const { isLoading, isError, error, data: tpReqData } = useQuery([QueryKey.singleTrkOpReq, trkOpReqId], () => getSingleTrkOpReq(trkOpReqId));
  let txtFielProps = { fontSize: 14, height: 33, width: 200 };
  let radioFieldProps = { fontSize: 14, gap: 8 };
  const [selection, setSelection] = useState({
    finalPayType: null,
    finalPricing: 0,
    basePrc: 0
  });
  const [breakUp, setBreakUp] = useState([])

  const payTypeArr = [
    { value: "full", label: t("bo.priceDet.fullPay") },
    { value: "advance", label: t("bo.priceDet.adv") },
    { value: "topay", label: t("bo.priceDet.toPay") }];

  const breakTypeArr = [
    { value: "addition", label: "Addition (+)" },
    { value: "deduction", label: "Deduction (-)" }];

  const additionBreakupDetArr = [
    { value: "aHalting", label: "Halting" },
    { value: "aUlCooliDrv", label: "UL Coolie Paid by Driver" },
    { value: "aLdCooliDrv", label: "Loading Coolie Paid by Driver" },
    { value: "aIncidental", label: "Incidental Charges" },
    { value: "aOthers", label: "Others" }
  ];

  const deductionBreakupDetArr = [
    { value: "dTds", label: "TDS" },
    { value: "dCommission", label: "Commission" },
    { value: "dPenalty", label: "Penalty" },
    { value: "dClaim", label: "Claim" },
    { value: "dLdCooli", label: "Loading Coolie" },
    { value: "dUlCooli", label: "Unloading Coolie" },
    { value: "dFrtLess", label: "Recd Freight Less" },
    { value: "dOthers", label: "Others" }
  ];


  useEffect(() => {
    if (!tpReqData)
      return;

    setSelection({
      finalPayType: tpReqData?.finalPayType,
      finalPricing: tpReqData?.finalPricing,
      basePrc: tpReqData?.basePrc
    })

    if (tpReqData?.trkOpPricingBreakup) {
      setBreakUp([...tpReqData?.trkOpPricingBreakup])
    }
  }, [tpReqData]);

  useEffect(() => {
    const base = parseFloat(selection.basePrc) || 0;

    let additions = 0;
    let deductions = 0;

    breakUp.forEach((item) => {
      const amt = parseFloat(item.breakup_amt) || 0;
      if (item.breakup_type === "addition") {
        additions += amt;
      } else if (item.breakup_type === "deduction") {
        deductions += amt;
      }
    });

    const final = base + additions - deductions;

    setSelection((prev) => ({
      ...prev,
      finalPricing: parseFloat(final.toFixed(2)) // rounded to 2 decimal places
    }));
  }, [selection.basePrc, breakUp]);

  async function handleSubmit(e) {
    e.preventDefault();


    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object

    // console.log(inputObject)

    inputObject.breakUp = breakUp;
    inputObject.custPayType = selection.finalPayType;
    let errorsObj = validate(inputObject);
    // console.log(errorsObj)
    setFormErrors(errorsObj);
    // console.log(errorsObj);

    if (Object.keys(errorsObj).length > 0)
      return;

    // console.log(inputObject)

    setLoadingScreen(true);
    try {
      const body = {
        truckOpReqId: trkOpReqId,
        basePrc: inputObject.basePrc,
        finalPricing: selection.finalPricing,
        finalPayType: inputObject.finalPayType,
        breakupArr: inputObject.breakUp,
        advance: inputObject.advance
      }
      await putTrkOpPricing({ body });
      notify("success", "Pricing Updated Successfully");
      navigate(route.boTrkOpReqInfo + trkOpReqId, { replace: true });
      queryClient.invalidateQueries();
      setLoadingScreen(false);
    } catch (err) {
      // console.log(err);
      customAlert(err);
    }
    setLoadingScreen(false);
  };


  async function handleCancel() {
    navigate(-1, { replace: true });
  }

  function handleRadioChange(e) {
    const { name, value } = e.target;
    const parsedValue = name === 'basePrc' ? parseFloat(value) || 0 : value;
    setSelection((e) => { return { ...e, [name]: parsedValue } });
  }

  const handleBreakupValChange = (index, e) => {
    const { name: field, value } = e.target;
    const updatedVal = [...breakUp];
    if (field === "breakup_type") {
      updatedVal[index].breakup_type = value;
      updatedVal[index].breakup_detail = "";
    } else if (field === "breakup_amt") {
      updatedVal[index][field] = parseFloat(value) || 0;
    } else {
      updatedVal[index][field] = value;
    }
    setBreakUp(updatedVal);
  };

  function addBreakup() {
    setBreakUp([
      ...breakUp,
      {
        breakup_type: "addition",
        breakup_detail: "",
        breakup_free_txt: "",
        breakup_amt: 0
      }
    ]);
  };

  function removeBreakup(index) {
    const updatedSpecs = [...breakUp];
    updatedSpecs.splice(index, 1);
    setBreakUp(updatedSpecs);
  };



  if (!tpReqData && trkOpReqId)
    return <h2>Invalid Shipment</h2>

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }


  if (isLoading)
    return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>

  if (tpReqData === null)
    return <h2>Invalid Shipment</h2>

  return (
    <BgBox >
      {tpReqData ? <form onSubmit={handleSubmit} noValidate id='addBo' style={{ padding: 0, height: "100%" }}>
        <Stack direction={'row'} justifyContent='space-between' mb={2} >
          <Typography variant='h6' sx={{ fontWeight: "bold" }}> {t("bo.priceDet.updateTrkOpPrc") + ` (${trkOpReqId})`}</Typography>
        </Stack>
        <Stack direction={"row"} height={"90%"} >
          <Stack width={"57%"}>
            <Stack direction={"row"} gap={1} alignItems={"end"}>
              <Stack direction={"row"} alignItems={"center"} gap={2}>
                <Box minWidth={200} />
                <Box minWidth={200} />
                <CtrlFillLabelTxtField type="number" step={0.5} defaultValue={tpReqData?.basePrc} name="basePrc"
                  title={t("bo.priceDet.basePrc")} errMsg={formErrors.basePrc} {...txtFielProps} height={38} onChange={handleRadioChange} />
              </Stack>
              <IconButton />
            </Stack>
            <Stack sx={{ mt: 1, mb: 2 }} direction={"row"} alignItems={"center"} gap={1} >
              <Typography sx={{ fontWeight: "bold", fontSize: 16 }}> {t("bo.priceDet.addDedBrek")}</Typography>
              <Button variant="contained" startIcon={<Add />} sx={{ borderRadius: 5, height: 30 }} onClick={addBreakup}>Add</Button>
            </Stack>
            <ScrollBox>
              {breakUp.map((i, index) => {
                const detailsArr = i.breakup_type === "addition" ? additionBreakupDetArr : deductionBreakupDetArr;
                return (
                  <Stack key={index} >
                    <Stack direction={"row"} gap={1} alignItems={"end"} mb={1}>
                      <Stack direction={"row"} alignItems={"center"} gap={2}>
                        <CustomDropDown title={t("bo.priceDet.brekType")} defaultValue={i.breakup_type} name={"breakup_type"} errMsg={formErrors[`breakup_type_${index}`]} handleDDChange={(e) => handleBreakupValChange(index, e)} ddArr={breakTypeArr} {...txtFielProps} />
                        <Stack>
                          <CustomDropDown title={t("bo.priceDet.brekDet")} defaultValue={i.breakup_detail} name={"breakup_detail"} errMsg={formErrors[`breakup_detail_${index}`]} handleDDChange={(e) => handleBreakupValChange(index, e)} ddArr={detailsArr} {...txtFielProps} />
                          {(i.breakup_detail === "aOthers" || i.breakup_detail === "dOthers") && (
                            <TextField
                              variant="outlined"
                              placeholder={"Enter details"}
                              name="breakup_free_txt"
                              value={i.breakup_free_txt}
                              onChange={(e) => handleBreakupValChange(index, e)}
                              error={!!formErrors[`breakup_free_txt_${index}`]}
                              helperText={formErrors[`breakup_free_txt_${index}`] || ""}
                              size="small"
                              sx={{
                                mt: 1, width: txtFielProps.width, "& .MuiInputBase-root": {
                                  height: txtFielProps.height,
                                  backgroundColor: "#F5F6F8",
                                  fontSize: txtFielProps.fontSize
                                },
                              }}
                            />
                          )}
                        </Stack>
                        <CtrlFillLabelTxtField type="number" step={0.5} defaultValue={i.breakup_amt} onChange={(e) => handleBreakupValChange(index, e)} name="breakup_amt" title={t("bo.priceDet.amount")} errMsg={formErrors[`breakup_amt_${index}`]} {...txtFielProps} />

                      </Stack>
                      <IconButton onClick={() => removeBreakup(index)} >
                        <DeleteForever sx={{ color: "red" }} />
                      </IconButton>
                    </Stack>

                  </Stack>
                )
              })}
            </ScrollBox>
          </Stack>
          <Divider orientation="vertical" flexItem sx={{ mr: 5 }} />
          <Stack height={"100%"} width={"40%"} justifyContent={"space-between"}>
            <Stack>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  border: '2px solid #0D47A1',
                  backgroundColor: '#E3F2FD',
                  borderRadius: '16px',
                  padding: 2,

                }}
              >
                <Typography variant="subtitle1" fontWeight="bold" color="#0D47A1">
                  Total Final Price
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {formatINRCurrency(selection.finalPricing)}
                </Typography>
              </Stack>
              <Stack direction={"row"} mt={3} mb={2}>
                <CustomRadio defaultValue={tpReqData?.finalPayType} title={t("bo.priceDet.payTypeTrkOp")} handleRadioChange={handleRadioChange}
                  name={"finalPayType"} errMsg={formErrors.custPayType} radioArr={payTypeArr} {...radioFieldProps} />
              </Stack>
              {/* {selection.finalPayType === "advance" && <FillLabelTxtField type="number" step={0.5} defaultValue={tpReqData?.advance}
                name="advance" title={t("bo.priceDet.advAmt")} errMsg={formErrors.advance} {...txtFielProps} height={38} />} */}
            </Stack>
            <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 1.5 }} width={"100%"}>
              <Button variant="text" sx={{ height: 40, width: 120, mr: 1 }} onClick={handleCancel}>{t("bo.editCustInfoPg.cancel")}</Button>
              <Button variant="contained" type='submit' sx={{ height: 40, width: 120 }}>{t("bo.editCustInfoPg.save")}</Button>
            </Stack>
          </Stack>

        </Stack>

      </form> : <Typography component={'h1'}>Something went wrong</Typography>}
    </BgBox>
  )
}

export default EditTrkOpPricing